import { RouteObject } from "react-router-dom";
// import { FormWizardPage } from "@features/formWizard/FormWizardPage";
//import LoginForm from "@features/auth/LoginForm";
import { PrivateRoute } from "@components/PrivateRoute";
// import { RoleBasedRoute } from "@components/RoleBasedRoute";
import Dashboard from "@features/dashboard/Dashboard";
import LoginPage from "@/features/Login/LoginPage";
import AssetTypeRoutes from "@features/assetType/AssetTypeRoutes";
import { PhaseFormRoutes } from "@/features/phaseForm/PhaseFormRoutes";
import { FormRouter } from "@/features/CompleteForm/FormRouter";
import { SuccessPage } from "@/features/formWizard/SuccessPage";
import SimplifiedSuccessPage from "@/features/FirstFormPage/SuccessPage";
import FilledFormRoutes from "@/features/filledForm/FilledFormRoutes";
import ProcessRoleRoutes from "@/features/processRole/ProcessRoleRoutes";
import { UserList } from "@/features/user";
import { RoleBasedRoute } from "@/components/RoleBasedRoute";
import { UserRole } from "@/features/user/types";
import ProductRoutes from "@/features/Element/ProductRoutes";
import AppointmentRoutes from "@/features/appointment/AppointmentRoutes";
import { MainContent } from "@/features/TechnicalPiece/MainContent";
import InputDesign from "@/features/process/InputDesign";
import { ActivityList } from "@/features/process";
import ForgotPasswordPage from "@/features/ForgotPassword/ForgotPasswordPage";
// import ProcessRoleRoutes from "@features/processRole/ProcessRoleRoutes";
// import PhaseFormRoutes from "@features/phaseForm/PhaseFormRoutes";
// import FormWizardRoutes from "@features/formWizard/FormWizardRoutes";
// import AffiliateRoutes from "@features/affiliate/AffiliateRoutes";
// import ProductRoutes from "@features/product/ProductRoutes";
import UserRoutes from "@features/user/UserRoutes";
import RoleRoutes from "@features/role/RoleRoutes";
import SectorRoutes from "@features/sector/SectorRoutes";
import DocumentRoutes from "@/features/document/DocumentRoutes";
import CategoryDocumentRoutes from "@/features/categorydocument/CategoryDocumentRoutes";
import TemplateRoutes from "@/features/template/TemplateRoutes";
import AreaRoutes from "@/features/area/AreaRoutes";
import TechinicalRoutes from "@/features/techinicaldocument/TechinicalRoutes";
import ClientRoutes from "@/features/Client/ClientRoutes";
import { SalesRoutes } from "@/features/sales/SalesRoutes";
import { PaymentLayout } from "@/features/sales/payment/PaymentLayout";
import { PaymentHome } from "@/features/sales/payment/PaymentHome";
import {
  PaymentPix,
  PaymentBankSlip,
  PaymentTed,
  PaymentCreditCard,
} from "@/features/sales/payment/flow";

// import UserList from "@features/user/UserList";
// import UserForm from "@features/user/UserForm";
// import { SuccessPage } from "@features/formWizard/SuccessPage";
// import FilledFormRoutes from "@features/filledForm/FilledFormRoutes";
// import { UserRole } from "@features/user/types";
// import { LoginPage as LoginPage1 } from "@components/front1/LoginPage";
// import { LoginPage as LoginPage2 } from "@components/front2/LoginPage";
// import { ActivityList as ProcessActivityList } from "@features/process/ActivityList";
// import { ActivityList as ScheduleActivityList } from "@features/schedule/ActivityList";
// ... outras importações ...

export const routes: RouteObject[] = [
  // Rota pública do formulário
  {
    path: "/forms/:id/:processId",
    element: <FormRouter />,
  },
  {
    path: "/forms/:id/:processId/:productId",
    element: <FormRouter />,
  },
  {
    path: "/forms/:id/:processId/:productId/:clientId",
    element: <FormRouter />,
  },
  {
    path: "/complete-forms/:id/:processId",
    element: <FormRouter />,
  },
  {
    path: "/complete-forms/:id/:processId/:productId",
    element: <FormRouter />,
  },
  {
    path: "/complete-forms/:id/:processId/:productId/:clientId",
    element: <FormRouter />,
  },
  {
    path: "/first-forms/:id/:processId",
    element: <FormRouter />,
  },
  {
    path: "/first-forms/:id/:processId/:productId",
    element: <FormRouter />,
  },
  {
    path: "/first-forms/:id/:processId/:productId/:clientId",
    element: <FormRouter />,
  },
  // Rota pública de login
  {
    path: "/login",
    element: <LoginPage />,
  },

  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/sales/payment/:id",
    element: <PaymentLayout />,
    children: [
      { index: true, element: <PaymentHome /> },
      { path: "pix", element: <PaymentPix /> },
      { path: "boleto", element: <PaymentBankSlip /> },
      { path: "ted", element: <PaymentTed /> },
      { path: "credit", element: <PaymentCreditCard /> },
    ],
  },
  // Rotas protegidas
  {
    path: "/",
    element: <PrivateRoute />,
    children: [
      {
        path: "technical-pieces",
        element: <MainContent />,
      },
      {
        path: "activities",
        element: <ActivityList />,
      },
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "products/*",
        element: <ProductRoutes />,
      },
      {
        path: "asset-types/*",
        element: <AssetTypeRoutes />,
      },
      {
        path: "process-roles/*",
        element: <ProcessRoleRoutes />,
      },
      {
        path: "phase-forms/*",
        element: <PhaseFormRoutes />,
      },
      {
        path: "appointments/*",
        element: <AppointmentRoutes />,
      },
      //     {
      //       path: "form-wizard/*",
      //       element: <FormWizardRoutes />,
      //     },
      //     {
      //       path: "affiliates/*",
      //       element: <AffiliateRoutes />,
      //     },
      //     {
      //       path: "products/*",
      //       element: <ProductRoutes />,
      //     },
      //     {
      //       path: "activities",
      //       element: <ProcessActivityList />,
      //     },
      //     {
      //       path: "schedule",
      //       element: <ScheduleActivityList />,
      //     },
      //     // User routes with role-based protection

      {
        path: "users/*",
        element: <UserRoutes />,
      },
      {
        path: "roles/*",
        element: <RoleRoutes />,
      },
      {
        path: "sectors/*",
        element: <SectorRoutes />,
      },
      {
        path: "documents/*",
        element: <DocumentRoutes />,
      },
      {
        path: "techinicals-documents/*",
        element: <TechinicalRoutes />,
      },

      {
        path: "categories-documents/*",
        element: <CategoryDocumentRoutes />,
      },

      {
        path: "templates/*",
        element: <TemplateRoutes />,
      },

      {
        path: "areas/*",
        element: <AreaRoutes />,
      },
      // {
      //   path: "users",
      //   element: (
      //     <RoleBasedRoute allowedRoles={[UserRole.ADMIN, UserRole.MANAGER]}>
      //       <UserList />
      //     </RoleBasedRoute>
      //   ),
      // },
      //     {
      //       path: "users/new",
      //       element: (
      //         <RoleBasedRoute allowedRoles={[UserRole.ADMIN, UserRole.MANAGER]}>
      //           <UserForm />
      //         </RoleBasedRoute>
      //       ),
      //     },
      //     {
      //       path: "users/edit/:id",
      //       element: (
      //         <RoleBasedRoute allowedRoles={[UserRole.ADMIN, UserRole.MANAGER]}>
      //           <UserForm />
      //         </RoleBasedRoute>
      //       ),
      //     },
      {
        path: "filled-forms/*",
        element: <FilledFormRoutes />,
      },
      {
        path: "clients/*",
        element: <ClientRoutes />,
      },
      {
        path: "sales/*",
        element: <SalesRoutes />,
      },
    ],
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
  {
    path: "/simplified-success",
    element: <SimplifiedSuccessPage />,
  },
];
